import {Injectable} from '@angular/core';
import {User} from '../_models';
import {StorageService} from './storage.service';
import {AlertService} from './alert.service';
import {environment} from '../../environments/environment';

@Injectable()
export class MouseflowService {
  constructor(protected storageService: StorageService,
              protected alertService: AlertService) {
  }

  isEnabled() {
    return this.storageService.get('mouseflow');
  }

  enable(user: User) {
    if (environment.mouseflowId) {
      let that = this
      setTimeout(() => {
        // @ts-ignore
        window._mfq = window._mfq || []
        // @ts-ignore
        window._mfq.push(['setVariable', 'panel', 'admin'])
        // @ts-ignore
        window._mfq.push(['setVariable', 'user', user.id]);
        // @ts-ignore
        window._mfq.push(['setVariable', 'email', user.email]);

        (function () {
          let mouseFlowUrl = `//cdn.mouseflow.com/projects/${environment.mouseflowId}.js`
          let alreadyAdded = !!document.getElementById('mouseflow-custom-tag')

          if (!alreadyAdded) {
            let mf = document.createElement('script')
            mf.type = 'text/javascript'
            mf.defer = true
            mf.src = mouseFlowUrl
            mf.id = 'mouseflow-custom-tag'
            document.getElementsByTagName('head')[0].appendChild(mf)
            that.storageService.set('mouseflow', true);
          }
        })()
      }, 500)
    }
  }

  disable() {
    if (environment.mouseflowId) {
      let element = document.getElementById('mouseflow-custom-tag')

      if (element) {
        element.remove();
        this.storageService.set('mouseflow', false);
      }
    }
  }
}
